// Start:: Importing Middleware
import auth from "../middleware/auth.js";
import Authentication from "../pages/Authentication.vue";
// End:: Importing Middleware

// Start:: Importing Router Components
import Vue from "vue";
import VueRouter from "vue-router";
// End:: Importing Router Components

// ============== Start:: Home Page Route
import AppContentWrapper from "../pages/AppContentWrapper.vue";
import HomePage from "../pages/HomePage.vue";
// ============== End:: Home Page Route

// ============== Start:: Roles Routes
import RolesHome from "../views/Cruds/Roles/Home.vue";
import AllRoles from "../views/Cruds/Roles/ShowAll.vue";
import EditRole from "../views/Cruds/Roles/Edit.vue";
import CreateRole from "../views/Cruds/Roles/Create.vue";
// ============== End:: Roles Routes

// ============== Start:: Financial Reports Routes
import FinancialReportsHome from "../views/Cruds/FinancialReports/Home.vue";
import AllFinancialReports from "../views/Cruds/FinancialReports/ShowAll.vue";
// ============== End:: Financial Reports Routes

// ============== Start:: Financial Reports Routes
import PackagesFinancialReportsHome from "../views/Cruds/PackagesFinancialReports/Home.vue";
import AllPackagesFinancialReports from "../views/Cruds/PackagesFinancialReports/ShowAll.vue";
// ============== End:: Financial Reports Routes

// ============== Start:: FinancialfinshedReports Routes
import FinancialFinshedReportsHome from "../views/Cruds/FinancialFinshedReports/Home.vue";
import AllFinancialFinshedReports from "../views/Cruds/FinancialFinshedReports/ShowAll.vue";
import ShowFinancialFinshedReport from "../views/Cruds/FinancialFinshedReports/Show.vue";
// ============== End:: FinancialfinshedReports Routes

// ============== Start:: FinancialOrders Routes
import FinancialOrdersHome from "../views/Cruds/FinancialOrders/Home.vue";
import AllFinancialOrders from "../views/Cruds/FinancialOrders/ShowAll.vue";
// ============== End:: FinancialOrders Routes

// ============== Start:: FinancialPack Routes
// import FinancialPackHome from "../views/Cruds/FinancialPack/Home.vue";
// import AllFinancialPack from "../views/Cruds/FinancialPack/ShowAll.vue";
// ============== End:: FinancialPack Routes

// ============== Start:: AppRates Routes
import AppRatesHome from "../views/Cruds/AppRates/Home.vue";
import AllAppRates from "../views/Cruds/AppRates/ShowAll.vue";
import ShowAppRate from "../views/Cruds/AppRates/Show.vue";
// ============== End:: AppRates Routes

// ============== Start:: StoreRates Routes
import StoreRatesHome from "../views/Cruds/StoreRates/Home.vue";
import AllStoreRates from "../views/Cruds/StoreRates/ShowAll.vue";
// ============== End:: StoreRates Routes

// ============== Start:: Admins Routes
import ShowAdmin from "../views/Cruds/Admins/Show.vue";
import EditAdmin from "../views/Cruds/Admins/Edit.vue";
import CreateAdmin from "../views/Cruds/Admins/Create.vue";
import AllAdmins from "../views/Cruds/Admins/ShowAll.vue";
import AdminsHome from "../views/Cruds/Admins/Home.vue";
// ============== End:: Admins Routes

// ============== Start:: login Routes
import LoginForm from "../views/Auth/LoginForm.vue";
import ResetPasswordEmailForm from "../views/Auth/ResetPasswordEmailForm.vue";
import EmailVerificationForm from "../views/Auth/EmailVerificationForm.vue";
import ChangePhoneNumberForm from "../views/Auth/ChangePhoneNumber.vue";
import ResetPasswordForm from "../views/Auth/ResetPasswordForm.vue";
// ============== End:: login Routes

// ============== Start:: Contact Messages Routes
import ContactMessagesHome from "../views/Cruds/ContactMessages/Home.vue";
import AllContactMessages from "../views/Cruds/ContactMessages/ShowAll.vue";
import showMessage from "../views/Cruds/ContactMessages/Show.vue";
// ============== End:: Contact Messages Routes

// ============== Start:: App Content Routes
import AppContentHome from "../views/Cruds/AppContent/Home.vue";
import GeneralSettings from "../views/Cruds/AppSettings/GeneralSettings.vue";
import AppSettings from "../views/Cruds/AppSettings/AppSettings.vue";
import StatisticsSettings from "../views/Cruds/AppSettings/StatisticsSettings.vue";
import AboutUs from "../views/Cruds/AppContent/AboutUs.vue";
import Terms from "../views/Cruds/AppContent/Terms.vue";
import DeleteAccount from "../views/Cruds/AppContent/DeleteAccount.vue";
import Rewards from "../views/Cruds/AppContent/Rewards.vue";
import Cashback from "../views/Cruds/AppContent/Cashback.vue";
import PrivacyPolicy from "../views/Cruds/AppContent/PrivacyPolicy.vue";
import Agreement from "../views/Cruds/AppContent/agreement.vue";
import Rental_price from "../views/Cruds/AppContent/rental_price.vue";
import TermsProvider from "../views/Cruds/AppContent/TermsProvider.vue";
// ============== End:: App Content Routes

// Start:: Questiions Router Components
import questionsHome from "../views/Cruds/FAQ/Home.vue";
import Allquestions from "../views/Cruds/FAQ/ShowAll.vue";
import Createquestions from "../views/Cruds/FAQ/Create.vue";
import Editquestions from "../views/Cruds/FAQ/Edit.vue";
// End:: Questions Router Components

// Start:: Students Router Components
import studentsHome from "../views/Cruds/Students/Home.vue";
import Allstudents from "../views/Cruds/Students/ShowAll.vue";
import Createstudents from "../views/Cruds/Students/Create.vue";
import Editstudents from "../views/Cruds/Students/Edit.vue";
import Showstudents from "../views/Cruds/Students/Show.vue";
// End:: Students Router Components

// ============ Start:: Users Routes
import UsersHome from "../views/Cruds/Users/Home.vue";
import AllUsers from "../views/Cruds/Users/ShowAll.vue";
import ShowUsers from "../views/Cruds/Users/Show.vue";
// ============ End:: Users Routes

// ============== Start:: Ads Routes
import AdsHome from "../views/Cruds/Ads/Home.vue";
import AllAds from "../views/Cruds/Ads/ShowAll.vue";
import CreateAds from "../views/Cruds/Ads/Create.vue";
import ShowAds from "../views/Cruds/Ads/Show.vue";
import EditAds from "../views/Cruds/Ads/Edit.vue";
// ============== End:: Ads Routes

// ============== Start:: Products Routes
import ProductsHome from "../views/Cruds/Products/Home.vue";
import AllProducts from "../views/Cruds/Products/ShowAll.vue";
import CreateProducts from "../views/Cruds/Products/Create.vue";
import ShowProducts from "../views/Cruds/Products/Show.vue";
import EditProducts from "../views/Cruds/Products/Edit.vue";
// ============== End:: Products Routes

// ============== Start:: Countries Routes
import CountriesHome from "../views/Cruds/Countries/Home.vue";
import AllCountries from "../views/Cruds/Countries/ShowAll.vue";
import CreateCountries from "../views/Cruds/Countries/Create.vue";
import ShowCountries from "../views/Cruds/Countries/Show.vue";
import EditCountries from "../views/Cruds/Countries/Edit.vue";
// ============== End:: Countries Routes

// ============== Start:: MarketingCodes Routes
import MarketingCodesHome from "../views/Cruds/MarketingCodes/Home.vue";
import AllMarketingCodes from "../views/Cruds/MarketingCodes/ShowAll.vue";
import CreateMarketingCodes from "../views/Cruds/MarketingCodes/Create.vue";
import ShowMarketingCodes from "../views/Cruds/MarketingCodes/Show.vue";
import EditMarketingCodes from "../views/Cruds/MarketingCodes/Edit.vue";
// ============== End:: MarketingCodes Routes

// ============== Start:: VehicleTypes Routes
import VehicleTypesHome from "../views/Cruds/VehicleTypes/Home.vue";
import AllVehicleTypes from "../views/Cruds/VehicleTypes/ShowAll.vue";
import CreateVehicleTypes from "../views/Cruds/VehicleTypes/Create.vue";
import ShowVehicleTypes from "../views/Cruds/VehicleTypes/Show.vue";
import EditVehicleTypes from "../views/Cruds/VehicleTypes/Edit.vue";
// ============== End:: VehicleTypes Routes
// ============== Start:: VehicleFeature Routes
import VehicleFeaturesHome from "../views/Cruds/VehicleFeatures/Home.vue";
import AllVehicleFeatures from "../views/Cruds/VehicleFeatures/ShowAll.vue";
import CreateVehicleFeatures from "../views/Cruds/VehicleFeatures/Create.vue";
import ShowVehicleFeatures from "../views/Cruds/VehicleFeatures/Show.vue";
import EditVehicleFeatures from "../views/Cruds/VehicleFeatures/Edit.vue";
// ============== End:: VehicleFeature Routes
// ============== Start:: vehiclebrands Routes
import vehiclebrandsHome from "../views/Cruds/vehiclebrands/Home.vue";
import Allvehiclebrands from "../views/Cruds/vehiclebrands/ShowAll.vue";
import Createvehiclebrands from "../views/Cruds/vehiclebrands/Create.vue";
import Showvehiclebrands from "../views/Cruds/vehiclebrands/Show.vue";
import Editvehiclebrands from "../views/Cruds/vehiclebrands/Edit.vue";
// ============== End:: VehicleTypes Routes
// ============== Start:: vehiclemodels Routes
import vehiclemodelsHome from "../views/Cruds/vehiclemodels/Home.vue";
import Allvehiclemodels from "../views/Cruds/vehiclemodels/ShowAll.vue";
import Createvehiclemodels from "../views/Cruds/vehiclemodels/Create.vue";
import Showvehiclemodels from "../views/Cruds/vehiclemodels/Show.vue";
import Editvehiclemodels from "../views/Cruds/vehiclemodels/Edit.vue";
// ============== End:: VehicleTypes Routes
// ============== Start:: geartypes Routes
import geartypesHome from "../views/Cruds/geartypes/Home.vue";
import Allgeartypes from "../views/Cruds/geartypes/ShowAll.vue";
import Creategeartypes from "../views/Cruds/geartypes/Create.vue";
import Showgeartypes from "../views/Cruds/geartypes/Show.vue";
import Editgeartypes from "../views/Cruds/geartypes/Edit.vue";
// ============== End:: VehicleTypes Routes
// ============== Start:: fueltypes Routes
import fueltypesHome from "../views/Cruds/fueltypes/Home.vue";
import Allfueltypes from "../views/Cruds/fueltypes/ShowAll.vue";
import Createfueltypes from "../views/Cruds/fueltypes/Create.vue";
import Showfueltypes from "../views/Cruds/fueltypes/Show.vue";
import Editfueltypes from "../views/Cruds/fueltypes/Edit.vue";
// ============== End:: VehicleTypes Routes

// ============== Start:: Hobbies Routes
import HobbiesHome from "../views/Cruds/Hobbies/Home.vue";
import AllHobbies from "../views/Cruds/Hobbies/ShowAll.vue";
import CreateHobbies from "../views/Cruds/Hobbies/Create.vue";
import ShowHobbies from "../views/Cruds/Hobbies/Show.vue";
import EditHobbies from "../views/Cruds/Hobbies/Edit.vue";
// ============== End:: Hobbies Routes
// ============== Start:: CustomerOpinions Routes
import CustomerOpinionsHome from "../views/Cruds/Opinions/Home.vue";
import AllCustomerOpinions from "../views/Cruds/Opinions/ShowAll.vue";
import CreateCustomerOpinions from "../views/Cruds/Opinions/Create.vue";
import ShowCustomerOpinions from "../views/Cruds/Opinions/Show.vue";
import EditCustomerOpinions from "../views/Cruds/Opinions/Edit.vue";
// ============== End:: CustomerOpinions Routes
// ============== Start:: Nationalities Routes
import NationalitiesHome from "../views/Cruds/Nationalities/Home.vue";
import AllNationalities from "../views/Cruds/Nationalities/ShowAll.vue";
import CreateNationalities from "../views/Cruds/Nationalities/Create.vue";
import ShowNationalities from "../views/Cruds/Nationalities/Show.vue";
import EditNationalities from "../views/Cruds/Nationalities/Edit.vue";
// ============== End:: Nationalities Routes

// ============== Start:: Durations Routes
import DurationsHome from "../views/Cruds/Durations/Home.vue";
import AllDurations from "../views/Cruds/Durations/ShowAll.vue";
import CreateDurations from "../views/Cruds/Durations/Create.vue";
import ShowDurations from "../views/Cruds/Durations/Show.vue";
import EditDurations from "../views/Cruds/Durations/Edit.vue";
// ============== End:: Durations Routes

// ============== Start:: Districts Routes
import DistrictsHome from "../views/Cruds/Districts/Home.vue";
import AllDistricts from "../views/Cruds/Districts/ShowAll.vue";
import CreateDistricts from "../views/Cruds/Districts/Create.vue";
import ShowDistricts from "../views/Cruds/Districts/Show.vue";
import EditDistricts from "../views/Cruds/Districts/Edit.vue";
// ============== End:: Districts Routes

// ============== Start:: Cities Routes
import CitiesHome from "../views/Cruds/Cities/Home.vue";
import AllCities from "../views/Cruds/Cities/ShowAll.vue";
import CreateCities from "../views/Cruds/Cities/Create.vue";
import ShowCities from "../views/Cruds/Cities/Show.vue";
import EditCities from "../views/Cruds/Cities/Edit.vue";
// ============== End:: Cities Routes

// ============== Start:: Areas Routes
import AreasHome from "../views/Cruds/Areas/Home.vue";
import AllAreas from "../views/Cruds/Areas/ShowAll.vue";
import CreateAreas from "../views/Cruds/Areas/Create.vue";
import ShowAreas from "../views/Cruds/Areas/Show.vue";
import EditAreas from "../views/Cruds/Areas/Edit.vue";
// ============== End:: Areas Routes

// ============== Start:: Sectors Routes
import SectorsHome from "../views/Cruds/Sectors/Home.vue";
import AllSectors from "../views/Cruds/Sectors/ShowAll.vue";
import CreateSectors from "../views/Cruds/Sectors/Create.vue";
import ShowSectors from "../views/Cruds/Sectors/Show.vue";
import EditSectors from "../views/Cruds/Sectors/Edit.vue";
// ============== End:: Sectors Routes

// ============== Start:: Services Routes
import ServicesHome from "../views/Cruds/Services/Home.vue";
import AllServices from "../views/Cruds/Services/ShowAll.vue";
import CreateServices from "../views/Cruds/Services/Create.vue";
import ShowServices from "../views/Cruds/Services/Show.vue";
import EditServices from "../views/Cruds/Services/Edit.vue";
// ============== End:: Services Routes

// ============== Start:: Workplaces Routes
import WorkplacesHome from "../views/Cruds/Workplaces/Home.vue";
import AllWorkplaces from "../views/Cruds/Workplaces/ShowAll.vue";
import CreateWorkplaces from "../views/Cruds/Workplaces/Create.vue";
import ShowWorkplaces from "../views/Cruds/Workplaces/Show.vue";
import EditWorkplaces from "../views/Cruds/Workplaces/Edit.vue";
// ============== End:: Workplaces Routes

// ============== Start:: WalletRequests Routes
import RequestWalletsHome from "../views/Cruds/WalletRequests/Home.vue";
import AllRequestWallets from "../views/Cruds/WalletRequests/ShowAll.vue";
// ============== End:: WalletRequests Routes

// ============== Start:: WalletHistory Routes
import WalletHistoryHome from "../views/Cruds/WalletHistory/Home.vue";
import AllWalletHistory from "../views/Cruds/WalletHistory/ShowAll.vue";
// ============== End:: WalletRequests Routes

// ============== Start:: Reasons Routes
import ReasonsHome from "../views/Cruds/Reasons/Home.vue";
import AllReasons from "../views/Cruds/Reasons/ShowAll.vue";
import CreateReasons from "../views/Cruds/Reasons/Create.vue";
import ShowReasons from "../views/Cruds/Reasons/Show.vue";
import EditReasons from "../views/Cruds/Reasons/Edit.vue";
// ============== End:: Reasons Routes

// ============== Start:: Banks Routes
import BanksHome from "../views/Cruds/Banks/Home.vue";
import AllBanks from "../views/Cruds/Banks/ShowAll.vue";
import CreateBanks from "../views/Cruds/Banks/Create.vue";
import ShowBanks from "../views/Cruds/Banks/Show.vue";
import EditBanks from "../views/Cruds/Banks/Edit.vue";
// ============== End:: Banks Routes

// ============== Start:: Payouts Routes
import PayoutsHome from "../views/Cruds/Payouts/Home.vue";
import AllPayouts from "../views/Cruds/Payouts/ShowAll.vue";
import ShowPayouts from "../views/Cruds/Payouts/Show.vue";
// ============== End:: Payouts Routes

// ============== Start:: Booking Payouts Routes
import BookingPayoutsHome from "../views/Cruds/BookingPayouts/Home.vue";
import AllBookingPayouts from "../views/Cruds/BookingPayouts/ShowAll.vue";
import ShowBookingPayout from "../views/Cruds/BookingPayouts/Show.vue";
// ============== End:: Booking Payouts Routes

// ============== Start:: Auctions Routes
import AuctionsHome from "../views/Cruds/Auctions/Home.vue";
import AllAuctions from "../views/Cruds/Auctions/ShowAll.vue";
import ShowAuctions from "../views/Cruds/Auctions/Show.vue";
// ============== End:: Auctions Routes

// ============== Start:: Packages Routes
import PackagesHome from "../views/Cruds/Packages/Home.vue";
import AllPackages from "../views/Cruds/Packages/ShowAll.vue";
import CreatePackages from "../views/Cruds/Packages/Create.vue";
import ShowPackages from "../views/Cruds/Packages/Show.vue";
import EditPackages from "../views/Cruds/Packages/Edit.vue";
// ============== End:: Packages Routes

// ============== Start:: orders Routes
import ordersHome from "../views/Cruds/Orders/Home.vue";
import Allorders from "../views/Cruds/Orders/ShowAll.vue";
import Showorders from "../views/Cruds/Orders/Show.vue";
// ============== End:: orders Routes

// ============== Start:: UserRequests Routes =================
import UserRequestsHome from "../views/Cruds/UserRequests/Home.vue";
import AllUserRequests from "../views/Cruds/UserRequests/ShowAll.vue";
import ShowUserRequests from "../views/Cruds/UserRequests/Show.vue";
// ============== Start:: UserRequests Routes =================

// ============== Start:: UserRequests Routes =================
import ClientRequestsHome from "../views/Cruds/ClientRequests/Home.vue";
import AllClientRequests from "../views/Cruds/ClientRequests/ShowAll.vue";
import ShowClientRequests from "../views/Cruds/ClientRequests/Show.vue";
// ============== Start:: UserRequests Routes =================

// ============== Start:: Teachers Routes
import TeachersHome from "../views/Cruds/Teachers/Home.vue";
import AllTeachers from "../views/Cruds/Teachers/ShowAll.vue";
import CreateTeachers from "../views/Cruds/Teachers/Create.vue";
import ShowTeachers from "../views/Cruds/Teachers/Show.vue";
import EditTeachers from "../views/Cruds/Teachers/Edit.vue";
// ============== End:: Teachers Routes

// ============== Start:: Blogs Routes
import BlogsHome from "../views/Cruds/Blogs/Home.vue";
import AllBlogs from "../views/Cruds/Blogs/ShowAll.vue";
import CreateBlogs from "../views/Cruds/Blogs/Create.vue";
import ShowBlogs from "../views/Cruds/Blogs/Show.vue";
import EditBlogs from "../views/Cruds/Blogs/Edit.vue";
// ============== End:: Blogs Routes

// ============== Start:: RoadRules Routes
import RoadRulesHome from "../views/Cruds/RoadRules/Home.vue";
import AllRoadRules from "../views/Cruds/RoadRules/ShowAll.vue";
import CreateRoadRules from "../views/Cruds/RoadRules/Create.vue";
import ShowRoadRules from "../views/Cruds/RoadRules/Show.vue";
import EditRoadRules from "../views/Cruds/RoadRules/Edit.vue";
// ============== End:: Blogs Routes

// ============== Start:: All Notifications Routes
import AllNotifications from "../views/Cruds/Notifications/ShowAll.vue";
import NotificationsHome from "../views/Cruds/Notifications/Home.vue";
import CreateNotifications from "../views/Cruds/Notifications/Create.vue";
import ShowNotificationsTable from "../views/Cruds/Notifications/Show.vue";
// import ShowNotificationsIcon from "../views/Cruds/Notifications/Test.vue";
import ShowAllNotifications from "../views/Cruds/Notifications/ShowAllNotifications.vue";

// ============== End:: All Notifications Routes

// ================== Start:: Clients Routes
import ClientsHome from "../views/Cruds/Clients/Home.vue";
import AllClients from "../views/Cruds/Clients/ShowAll.vue";
import CreateClients from "../views/Cruds/Clients/Create.vue";
import EditClients from "../views/Cruds/Clients/Edit.vue";
import ShowClients from "../views/Cruds/Clients/Show.vue";
// ================= End:: Clients Routes
// ================== Start:: Providers Routes
import ProvidersHome from "../views/Cruds/Providers/Home.vue";
import AllProviders from "../views/Cruds/Providers/ShowAll.vue";
import CreateProviders from "../views/Cruds/Providers/Create.vue";
import EditProviders from "../views/Cruds/Providers/Edit.vue";
import ShowProviders from "../views/Cruds/Providers/Show.vue";
// ================= End:: Providers Routes
// ================== Start:: vehiclesmanagement Routes
import vehiclesmanagementHome from "../views/Cruds/Vehiclesmanagement/Home.vue";
import Allvehiclesmanagement from "../views/Cruds/Vehiclesmanagement/ShowAll.vue";
import Editvehiclesmanagement from "../views/Cruds/Vehiclesmanagement/Edit.vue";
import Showvehiclesmanagement from "../views/Cruds/Vehiclesmanagement/Show.vue";
// ================= End:: vehiclesmanagement Routes

// ================== Start:: servicesmanagement Routes
import servicesmanagementHome from "../views/Cruds/servicesmanagement/Home.vue";
import Allservicesmanagement from "../views/Cruds/servicesmanagement/ShowAll.vue";
import Editservicesmanagement from "../views/Cruds/servicesmanagement/Edit.vue";
import Showservicesmanagement from "../views/Cruds/servicesmanagement/Show.vue";
// ================= End:: servicesmanagement Routes

// ================== Start:: bookings Routes
import BookingsHome from "../views/Cruds/Bookings/Home.vue";
import AllBookings from "../views/Cruds/Bookings/ShowAll.vue";
import EditBookings from "../views/Cruds/Bookings/Edit.vue";
import ShowBookings from "../views/Cruds/Bookings/Show.vue";
// ================= End:: bookings Routes

// ================== Start:: vehicles Routes
import VehiclesHome from "../views/Cruds/vehicles/Home.vue";
import AllVehicles from "../views/Cruds/vehicles/ShowAll.vue";
import EditVehicles from "../views/Cruds/vehicles/Edit.vue";
import ShowVehicles from "../views/Cruds/vehicles/Show.vue";
// ================= End:: vehicles Routes

// ================== Start:: Additional Services Routes
import AdditionalServicesHome from "../views/Cruds/AdditionalServices/Home.vue";
import AllAdditionalServices from "../views/Cruds/AdditionalServices/ShowAll.vue";
import EditAdditionalServices from "../views/Cruds/AdditionalServices/Edit.vue";
import ShowAdditionalServices from "../views/Cruds/AdditionalServices/Show.vue";
// ================= End:: Additional Services Routes

// ================== Start:: Customers Routes
import CustomersHome from "../views/Cruds/Customers/Home.vue";
import AllCustomers from "../views/Cruds/Customers/ShowAll.vue";
import CreateCustomers from "../views/Cruds/Customers/Create.vue";
import EditCustomers from "../views/Cruds/Customers/Edit.vue";
import ShowCustomers from "../views/Cruds/Customers/Show.vue";
// ================= End:: Customers Routes

//=============== Start:: Order Desiginer Routes
import OrdersRequestsHome from "../views/Cruds/OrdersRequests/Home.vue";
import AllOrdersRequests from "../views/Cruds/OrdersRequests/ShowAll.vue";
import ShowOrdersRequests from "../views/Cruds/OrdersRequests/Show.vue";
//============== End:: Order Desiginer Routes

// ============== Start:: MainCategories Routes
// import CategoriesHome from "../views/Cruds/MainCategories/Home.vue";
// import AllCategories from "../views/Cruds/MainCategories/ShowAll.vue";
// import CreateCategories from "../views/Cruds/MainCategories/Create.vue";
// import EditCategories from "../views/Cruds/MainCategories/Edit.vue";
// import ShowCategories from "../views/Cruds/MainCategories/Show.vue";
// ============== End:: MainCategories Routes

// ============== Start:: Academic Stages Routes
import AcademicStagesHome from "../views/Cruds/AcademicStages/Home.vue";
import AllAcademicStages from "../views/Cruds/AcademicStages/ShowAll.vue";
import CreateAcademicStages from "../views/Cruds/AcademicStages/Create.vue";
import EditAcademicStages from "../views/Cruds/AcademicStages/Edit.vue";
// ============== End:: Academic Stages Routes

// ============== Start:: Academic Years Routes
import AcademicYearsHome from "../views/Cruds/AcademicYears/Home.vue";
import AllAcademicYears from "../views/Cruds/AcademicYears/ShowAll.vue";
import CreateAcademicYears from "../views/Cruds/AcademicYears/Create.vue";
import EditAcademicYears from "../views/Cruds/AcademicYears/Edit.vue";
// ============== End:: Academic Years Routes

// ============== Start:: Specializations Routes
import SpecializationsHome from "../views/Cruds/Specializations/Home.vue";
import AllSpecializations from "../views/Cruds/Specializations/ShowAll.vue";
import CreateSpecializations from "../views/Cruds/Specializations/Create.vue";
import EditSpecializations from "../views/Cruds/Specializations/Edit.vue";
// ============== End:: Specializations Routes

// ============== Start:: subjects Routes
import SubjectsHome from "../views/Cruds/Subjects/Home.vue";
import AllSubjects from "../views/Cruds/Subjects/ShowAll.vue";
import CreateSubjects from "../views/Cruds/Subjects/Create.vue";
import EditSubjects from "../views/Cruds/Subjects/Edit.vue";
import ShowSubjects from "../views/Cruds/Subjects/Show.vue";
// ============== End:: subjects Routes

// ============== Start:: Categories Routes
import CategoriesHome from "../views/Cruds/Categories/Home.vue";
import AllCategories from "../views/Cruds/Categories/ShowAll.vue";
import CreateCategories from "../views/Cruds/Categories/Create.vue";
import EditCategories from "../views/Cruds/Categories/Edit.vue";
// ============== End:: Categories Routes

// ============== Start:: SubCategories Routes
import SubCategoriesHome from "../views/Cruds/SubCategories/Home.vue";
import AllSubCategories from "../views/Cruds/SubCategories/ShowAll.vue";
import CreateSubCategories from "../views/Cruds/SubCategories/Create.vue";
import EditSubCategories from "../views/Cruds/SubCategories/Edit.vue";
import ShowSubCategories from "../views/Cruds/SubCategories/Show.vue";
// ============== End:: SubCategories Routes
// ============== Start:: Coupons Routes
import CouponsHome from "../views/Cruds/Coupons/Home.vue";
import AllCoupons from "../views/Cruds/Coupons/ShowAll.vue";
import CreateCoupons from "../views/Cruds/Coupons/Create.vue";
import ShowCoupons from "../views/Cruds/Coupons/Show.vue";
import EditCoupons from "../views/Cruds/Coupons/Edit.vue";
// ============== End:: Coupons Routes

// ============== Start:: Capacities Routes
import CapacitiesHome from "../views/Cruds/Capacities/Home.vue";
import AllCapacities from "../views/Cruds/Capacities/ShowAll.vue";
import CreateCapacities from "../views/Cruds/Capacities/Create.vue";
import ShowCapacities from "../views/Cruds/Capacities/Show.vue";
import EditCapacities from "../views/Cruds/Capacities/Edit.vue";
// ============== End:: Capacities Routes

// ============== Start:: ResidentialAdd Routes
import ResidentialAddHome from "../views/Cruds/ResidentialAdd/Home.vue";
import AllResidentialAdd from "../views/Cruds/ResidentialAdd/ShowAll.vue";
import CreateResidentialAdd from "../views/Cruds/ResidentialAdd/Create.vue";
import ShowResidentialAdd from "../views/Cruds/ResidentialAdd/Show.vue";
import EditResidentialAdd from "../views/Cruds/ResidentialAdd/Edit.vue";
// ============== End:: ResidentialAdd Routes

// ============== Start:: Managements Routes
import ManagementsHome from "../views/Cruds/Managements/Home.vue";
import AllManagements from "../views/Cruds/Managements/ShowAll.vue";
import CreateManagements from "../views/Cruds/Managements/Create.vue";
import EditManagements from "../views/Cruds/Managements/Edit.vue";
import ShowManagements from "../views/Cruds/Managements/Show.vue";
// ============== End:: Managements Routes

// ============== Start:: Complaints Routes
import ComplaintsList from "../views/Cruds/Complaints/ComplaintsList.vue";
// ============== End:: Complaints Routes

// ============== Start:: Chatbot FAQs Routes
import ChatbotFaqsList from "../views/Cruds/ChatbotFaqs/ChatbotFaqsList.vue";
// ============== End:: Chatbot FAQs Routes

// ============== Start:: Chatbot Conversations Routes
import ChatbotConversations from "../views/Cruds/ChatbotConversations/ChatbotConversations.vue";
// ============== End:: Chatbot Conversations Routes

// ============== Start:: Wallet Withdrawal Requests Routes
import ProviderWalletRequests from "../views/Cruds/WalletRequests/ProviderWalletRequests.vue";
import DeliveryWalletRequests from "../views/Cruds/WalletRequests/DeliveryWalletRequests.vue";
// ============== End:: Wallet Withdrawal Requests Routes

// ============== Start:: Forbidden Route
import ForbiddenPage from "../pages/ForbiddenPage.vue";
// ============== End:: Forbidden Route

// ============== Start:: Not Found Route
import NotFoundPage from "../pages/NotFound.vue";
// ============== End:: Not Found Route

// End:: Importing Router Components

Vue.use(VueRouter);
const routes = [
  // ***************** Start:: Auth Routes Config
  {
    path: "/",
    component: Authentication,
    children: [
      {
        path: "/",
        component: LoginForm,
        name: "LoginForm",
      },
      {
        path: "/reset-password-email",
        name: "ResetPasswordEmailForm",
        component: ResetPasswordEmailForm,
      },
      {
        path: "/email-verification/:verification_type",
        name: "EmailVerificationForm",
        component: EmailVerificationForm,
      },
      {
        path: "/chang-phone-number",
        name: "ChangePhoneNumberForm",
        component: ChangePhoneNumberForm,
      },
      {
        path: "/reset-password",
        name: "ResetPasswordForm",
        component: ResetPasswordForm,
      },
    ],
  },
  // ***************** End:: Auth Routes Config

  // ***************** Start:: Content Routes Config
  {
    path: "/home",
    component: AppContentWrapper,
    children: [
      // Start:: Home Route Config
      {
        path: "/home",
        component: HomePage,
        meta: {
          middleware: [auth],
        },
      },
      // End:: Home Route Config

      // Start:: Contact Messages Routes Config
      {
        path: "/contact-messages",
        name: "ContactMessagesHome",
        component: ContactMessagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllContactMessages",
            component: AllContactMessages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "contacts index",
                subject: "contacts",
              },
            },
          },
          {
            path: "show/:id",
            name: "showMessage",
            component: showMessage,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "contacts show",
                subject: "contacts",
              },
            },
          },
        ],
      },
      // End:: Contact Messages Routes Config

      // Start:: App Content Routes Config
      {
        path: "/app-content",
        name: "AppContentHome",
        component: AppContentHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "about-us",
            name: "AboutUs",
            component: AboutUs,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "terms",
            name: "Terms",
            component: Terms,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "policy",
            name: "PrivacyPolicy",
            component: PrivacyPolicy,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "agreement",
            name: "Privacyagreement",
            component: Agreement,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "rental_price",
            name: "Privacyrental_price",
            component: Rental_price,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "provider-terms",
            name: "TermsProvider",
            component: TermsProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "delete-account",
            name: "DeleteAccount",
            component: DeleteAccount,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "rewards",
            name: "Rewards",
            component: Rewards,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "cashback",
            name: "Cashback",
            component: Cashback,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
        ],
      },
      // End:: App Content Routes Config

      // Start:: AllFinancialOrders Routes Config
      // {
      //   path: "/financialorders",
      //   name: "FinancialOrdersHome",
      //   component: FinancialOrdersHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllFinancialOrders",
      //       component: AllFinancialOrders,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "roles index",
      //           subject: "roles",
      //         },
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: "/financialpack",
      //   name: "FinancialPackHome",
      //   component: FinancialPackHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllFinancialPack",
      //       component: AllFinancialPack,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "roles index",
      //           subject: "roles",
      //         },
      //       },
      //     },
      //   ],
      // },

      // Start:: Financial Reports Routes Config
      {
        path: "/financial-reports",
        name: "FinancialReportsHome",
        component: FinancialReportsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialReports",
            component: AllFinancialReports,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reports index",
                subject: "reports",
              },
            },
          },
        ],
      },

      {
        path: "/financial-finished-reports",
        name: "FinancialFinshedReportsHome",
        component: FinancialFinshedReportsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialFinshedReports",
            component: AllFinancialFinshedReports,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "financial_reports finishedordersreports",
                subject: "financial_reports",
              },
            },
          },
        ],
      },
      // End:: Financial Reports Routes Config

      // Start:: Packages Financial Reports Routes Config
      {
        path: "/packages-financial-reports",
        name: "PackagesFinancialReportsHome",
        component: PackagesFinancialReportsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllPackagesFinancialReports",
            component: AllPackagesFinancialReports,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "financialreports packages",
                subject: "financialreports",
              },
            },
          },
        ],
      },
      // End:: Packages Financial Reports Routes Config

      // Start:: Roles Routes Config
      {
        path: "/roles",
        name: "RolesHome",
        component: RolesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRoles",
            component: AllRoles,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "-",
                subject: "roles",
              },
            },
          },
          {
            path: "create",
            name: "CreateRole",
            component: CreateRole,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles create",
                subject: "roles",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditRole",
            component: EditRole,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles edit",
                subject: "roles",
              },
            },
          },
        ],
      },
      // End:: Roles Routes Config

      // Start:: Admins Routes Config
      {
        path: "/admins",
        name: "AdminsHome",
        component: AdminsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdmins",
            component: AllAdmins,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins index",
                subject: "admins",
              },
            },
          },
          {
            path: "create",
            name: "CreateAdmin",
            component: CreateAdmin,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins create",
                subject: "admins",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAdmin",
            component: EditAdmin,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins edit",
                subject: "admins",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAdmin",
            component: ShowAdmin,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins show",
                subject: "admins",
              },
            },
          },
        ],
      },
      // End:: Admins Routes Config

      // Start:: users Routes Config
      {
        path: "/users",
        name: "UsersHome",
        component: UsersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUsers",
            component: AllUsers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowUsers",
            component: ShowUsers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users show",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: users Routes Config

      // Start:: products  Config
      // {
      //   path: "/products",
      //   name: "products",
      //   component: ProductsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Allproducts",
      //       component: AllProducts,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "products index",
      //           subject: "products",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "Createproducts",
      //       component: CreateProducts,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "products create",
      //           subject: "products",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "Editproducts",
      //       component: EditProducts,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "products edit",
      //           subject: "products",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showproducts",
      //       component: ShowProducts,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "products show",
      //           subject: "products",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: products Config

      // Start:: orders  Config
      // {
      //   path: "/orders",
      //   name: "orders",
      //   component: ordersHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Allorders",
      //       component: Allorders,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "orders index",
      //           subject: "orders",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showorders",
      //       component: Showorders,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "orders show",
      //           subject: "orders",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: orders Config

      // Start:: nationalities  Config
      {
        path: "/nationalities",
        name: "nationalities",
        component: NationalitiesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allnationalities",
            component: AllNationalities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "nationalities index",
                subject: "nationalities",
              },
            },
          },
          {
            path: "create",
            name: "Createnationalities",
            component: CreateNationalities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "nationalities create",
                subject: "nationalities",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editnationalities",
            component: EditNationalities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "nationalities edit",
                subject: "nationalities",
              },
            },
          },
          {
            path: "show/:id",
            name: "Shownationalities",
            component: ShowNationalities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "nationalities show",
                subject: "nationalities",
              },
            },
          },
        ],
      },
      // End:: nationalities Config
      // Start:: hobbies  Config
      {
        path: "/hobbies",
        name: "hobbies",
        component: HobbiesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allhobbies",
            component: AllHobbies,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "hobbies index",
                subject: "hobbies",
              },
            },
          },
          {
            path: "create",
            name: "Createhobbies",
            component: CreateHobbies,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "hobbies create",
                subject: "hobbies",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Edithobbies",
            component: EditHobbies,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "hobbies edit",
                subject: "hobbies",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showhobbies",
            component: ShowHobbies,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "hobbies show",
                subject: "hobbies",
              },
            },
          },
        ],
      },
      // End:: hobbies Config
      // Start:: CustomerOpinions  Config
      {
        path: "/customeropinions",
        name: "customeropinions",
        component: CustomerOpinionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCustomerOpinions",
            component: AllCustomerOpinions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "customeropinions index",
                subject: "customeropinions",
              },
            },
          },
          {
            path: "create",
            name: "CreateCustomerOpinions",
            component: CreateCustomerOpinions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "customeropinions create",
                subject: "customeropinions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCustomerOpinions",
            component: EditCustomerOpinions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "customeropinions edit",
                subject: "customeropinions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCustomerOpinions",
            component: ShowCustomerOpinions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "customeropinions show",
                subject: "customeropinions",
              },
            },
          },
        ],
      },
      // End:: CustomerOpinions Config
      // Start:: countries Config
      {
        path: "/countries",
        name: "countries",
        component: CountriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allcountries",
            component: AllCountries,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "countries index",
                subject: "countries",
              },
            },
          },
          {
            path: "create",
            name: "Createcountries",
            component: CreateCountries,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "countries create",
                subject: "countries",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editcountries",
            component: EditCountries,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "countries edit",
                subject: "countries",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showcountries",
            component: ShowCountries,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "countries show",
                subject: "countries",
              },
            },
          },
        ],
      },
      // End:: countries Config
      // Start:: marketingCodes Config
      {
        path: "/marketing-codes",
        name: "marketingCodes",
        component: MarketingCodesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllmarketingCodes",
            component: AllMarketingCodes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "marketingcodes index",
                subject: "marketingcodes",
              },
            },
          },
          {
            path: "create",
            name: "CreatemarketingCodes",
            component: CreateMarketingCodes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "marketingcodes create",
                subject: "marketingcodes",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditmarketingCodes",
            component: EditMarketingCodes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "marketingcodes edit",
                subject: "marketingcodes",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowmarketingCodes",
            component: ShowMarketingCodes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "marketingcodes show",
                subject: "marketingcodes",
              },
            },
          },
        ],
      },
      // End:: marketingCodes Config
      // Start:: VehicleTypes Config
      {
        path: "/vehicle-types",
        name: "VehicleTypes",
        component: VehicleTypesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllVehicleTypes",
            component: AllVehicleTypes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehicletypes index",
                subject: "vehicletypes",
              },
            },
          },
          {
            path: "create",
            name: "CreateVehicleTypes",
            component: CreateVehicleTypes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehicletypes create",
                subject: "vehicletypes",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditVehicleTypes",
            component: EditVehicleTypes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehicletypes edit",
                subject: "vehicletypes",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowVehicleTypes",
            component: ShowVehicleTypes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehicletypes show",
                subject: "vehicletypes",
              },
            },
          },
        ],
      },
      // End:: VehicleTypes Config
      // Start:: VehicleFeature Config
      {
        path: "/vehicle-features",
        name: "VehicleFeatures",
        component: VehicleFeaturesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllVehicleFeatures",
            component: AllVehicleFeatures,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "features index",
                subject: "features",
              },
            },
          },
          {
            path: "create",
            name: "CreateVehicleFeatures",
            component: CreateVehicleFeatures,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "features create",
                subject: "features",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditVehicleFeatures",
            component: EditVehicleFeatures,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "features edit",
                subject: "features",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowVehicleFeatures",
            component: ShowVehicleFeatures,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "features show",
                subject: "features",
              },
            },
          },
        ],
      },
      // End:: VehicleFeatures Config
      // Start:: vehiclebrands Config
      {
        path: "/vehiclebrands",
        name: "vehiclebrands",
        component: vehiclebrandsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allvehiclebrands",
            component: Allvehiclebrands,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclebrands index",
                subject: "vehiclebrands",
              },
            },
          },
          {
            path: "create",
            name: "Createvehiclebrands",
            component: Createvehiclebrands,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclebrands create",
                subject: "vehiclebrands",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editvehiclebrands",
            component: Editvehiclebrands,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclebrands edit",
                subject: "vehiclebrands",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showvehiclebrands",
            component: Showvehiclebrands,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclebrands show",
                subject: "vehiclebrands",
              },
            },
          },
        ],
      },
      // End:: vehiclebrands Config
      // Start:: vehiclemodels Config
      {
        path: "/vehiclemodels",
        name: "vehiclemodels",
        component: vehiclemodelsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allvehiclemodels",
            component: Allvehiclemodels,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclemodels index",
                subject: "vehiclemodels",
              },
            },
          },
          {
            path: "create",
            name: "Createvehiclemodels",
            component: Createvehiclemodels,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclemodels create",
                subject: "vehiclemodels",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editvehiclemodels",
            component: Editvehiclemodels,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclemodels edit",
                subject: "vehiclemodels",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showvehiclemodels",
            component: Showvehiclemodels,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclemodels show",
                subject: "vehiclemodels",
              },
            },
          },
        ],
      },
      // End:: vehiclemodels Config
      // Start:: geartypes Config
      {
        path: "/geartypes",
        name: "geartypes",
        component: geartypesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allgeartypes",
            component: Allgeartypes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "geartypes index",
                subject: "geartypes",
              },
            },
          },
          {
            path: "create",
            name: "Creategeartypes",
            component: Creategeartypes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "geartypes create",
                subject: "geartypes",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editgeartypes",
            component: Editgeartypes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "geartypes edit",
                subject: "geartypes",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showgeartypes",
            component: Showgeartypes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "geartypes show",
                subject: "geartypes",
              },
            },
          },
        ],
      },
      // End:: geartypes Config
      // Start:: fueltypes Config
      {
        path: "/fueltypes",
        name: "fueltypes",
        component: fueltypesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allfueltypes",
            component: Allfueltypes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "fueltypes index",
                subject: "fueltypes",
              },
            },
          },
          {
            path: "create",
            name: "Createfueltypes",
            component: Createfueltypes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "fueltypes create",
                subject: "fueltypes",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editfueltypes",
            component: Editfueltypes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "fueltypes edit",
                subject: "fueltypes",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showfueltypes",
            component: Showfueltypes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "fueltypes show",
                subject: "fueltypes",
              },
            },
          },
        ],
      },
      // End:: fueltypes Config

      // Start:: districts  Config
      {
        path: "/districts",
        name: "districts",
        component: DistrictsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Alldistricts",
            component: AllDistricts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts index",
                subject: "districts",
              },
            },
          },
          {
            path: "create",
            name: "Createdistricts",
            component: CreateDistricts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts create",
                subject: "districts",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editdistricts",
            component: EditDistricts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts edit",
                subject: "districts",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showdistricts",
            component: ShowDistricts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts show",
                subject: "districts",
              },
            },
          },
        ],
      },
      // End:: districts Config

      // Start:: Cities  Config
      {
        path: "/cities",
        name: "cities",
        component: CitiesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allcities",
            component: AllCities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities index",
                subject: "cities",
              },
            },
          },
          {
            path: "create",
            name: "Createcities",
            component: CreateCities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities create",
                subject: "cities",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editcities",
            component: EditCities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities edit",
                subject: "cities",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showcities",
            component: ShowCities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities show",
                subject: "cities",
              },
            },
          },
        ],
      },
      // End:: Cities Config

      // Start:: Rates Routes Config
      // {
      //   path: "/rates",
      //   name: "RatesHome",
      //   component: RatesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllRates",
      //       component: AllRates,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "reviews index",
      //           subject: "reviews",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: Rates Routes Config

      // Start:: RegionsHome  Config
      {
        path: "/areas",
        name: "areas",
        component: AreasHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAreas",
            component: AllAreas,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "areas index",
                subject: "areas",
              },
            },
          },
          {
            path: "create",
            name: "CreateAreas",
            component: CreateAreas,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "areas create",
                subject: "areas",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAreas",
            component: EditAreas,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "areas edit",
                subject: "areas",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAreas",
            component: ShowAreas,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "areas show",
                subject: "areas",
              },
            },
          },
        ],
      },
      // End:: Areas Config

      // Start:: services  Config
      {
        path: "/services",
        name: "services",
        component: ServicesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allservices",
            component: AllServices,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services index",
                subject: "services",
              },
            },
          },
          {
            path: "create",
            name: "Createservices",
            component: CreateServices,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services create",
                subject: "services",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editservices",
            component: EditServices,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services edit",
                subject: "services",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showservices",
            component: ShowServices,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services show",
                subject: "services",
              },
            },
          },
        ],
      },
      // End:: services Config

      // Start:: Sectors Config
      {
        path: "/sectors",
        name: "sectors",
        component: SectorsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSectors",
            component: AllSectors,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sections index",
                subject: "sections",
              },
            },
          },
          {
            path: "create",
            name: "CreateSectors",
            component: CreateSectors,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sections create",
                subject: "sections",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditSectors",
            component: EditSectors,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sections edit",
                subject: "sections",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowSectors",
            component: ShowSectors,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sections show",
                subject: "sections",
              },
            },
          },
        ],
      },
      // End:: Sectors Config

      // Start:: customers Config
      {
        path: "/customers",
        name: "customers",
        component: ServicesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allcustomers",
            component: AllCustomers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services index",
                subject: "services",
              },
            },
          },
          {
            path: "create",
            name: "Createcustomers",
            component: CreateCustomers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "customers create",
                subject: "customers",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editcustomers",
            component: EditCustomers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "customers edit",
                subject: "customers",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showcustomers",
            component: ShowCustomers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "customers show",
                subject: "customers",
              },
            },
          },
        ],
      },
      // End:: customers Config

      // Start:: reasons  Config
      // {
      //   path: "/reasons",
      //   name: "reasons",
      //   component: ReasonsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Allreasons",
      //       component: AllReasons,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "reasons index",
      //           subject: "reasons",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "Createreasons",
      //       component: CreateReasons,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "reasons create",
      //           subject: "reasons",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "Editreasons",
      //       component: EditReasons,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "reasons edit",
      //           subject: "reasons",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showreasons",
      //       component: ShowReasons,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "reasons show",
      //           subject: "reasons",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: reasons Config

      // Start:: workplaces  Config
      // {
      //   path: "/workplaces",
      //   name: "workplaces",
      //   component: WorkplacesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Allworkplaces",
      //       component: AllWorkplaces,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "workplaces index",
      //           subject: "workplaces",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "Createworkplaces",
      //       component: CreateWorkplaces,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "workplaces create",
      //           subject: "workplaces",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "Editworkplaces",
      //       component: EditWorkplaces,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "workplaces edit",
      //           subject: "workplaces",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showworkplaces",
      //       component: ShowWorkplaces,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "workplaces show",
      //           subject: "workplaces",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: workplaces Config

      // Start:: WalletRequests  Config
      {
        path: "/request-wallets",
        name: "RequestWallets",
        component: RequestWalletsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRequestWallets",
            component: AllRequestWallets,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "withdraw_requests index",
                subject: "withdraw_requests",
              },
            },
          },
        ],
      },
      // End:: WalletRequests Config

      // start::designers orders
      {
        path: "/joinClients",
        name: "ClientRequestsHome",
        component: ClientRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllClientRequests",
            component: AllClientRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients index",
                subject: "clients",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowClientRequests",
            component: ShowClientRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients show",
                subject: "clients",
              },
            },
          },
        ],
      },
      // End::designers orders

      // start::user requests
      {
        path: "/teachers-requests",
        name: "UserRequestsHome",
        component: UserRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUserRequests",
            component: AllUserRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "teacher requests index",
                subject: "teacher-requests",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowUserRequests",
            component: ShowUserRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "teacher requests show",
                subject: "teacher-requests",
              },
            },
          },
        ],
      },
      // End::user requests

      // Start:: WalletHistory  Config
      // {
      //   path: "/WalletHistory",
      //   name: "WalletHistory",
      //   component: WalletHistoryHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all/:id",
      //       name: "AllWalletHistory",
      //       component: AllWalletHistory,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "users index",
      //           subject: "users",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: WalletHistory Config

      // Start:: Teachers  Config
      {
        path: "/teachers",
        name: "teachers",
        component: TeachersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllTeachers",
            component: AllTeachers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "teachers index",
                subject: "teachers",
              },
            },
          },
          {
            path: "create",
            name: "CreateTeachers",
            component: CreateTeachers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "teachers create",
                subject: "teachers",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditTeachers",
            component: EditTeachers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "teachers edit",
                subject: "teachers",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowTeachers",
            component: ShowTeachers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "teachers show",
                subject: "teachers",
              },
            },
          },
        ],
      },
      // End:: Teachers Config

      // Start:: Blogs  Config
      {
        path: "/blogs",
        name: "blogs",
        component: BlogsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllBlogs",
            component: AllBlogs,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "blogs index",
                subject: "blogs",
              },
            },
          },
          {
            path: "create",
            name: "CreateBlogs",
            component: CreateBlogs,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "blogs create",
                subject: "blogs",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditBlogs",
            component: EditBlogs,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "blogs edit",
                subject: "blogs",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowBlogs",
            component: ShowBlogs,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "blogs show",
                subject: "blogs",
              },
            },
          },
        ],
      },
      // End:: Blogs Config

      // Start:: RoadRules  Config
      {
        path: "/road-rules",
        name: "RoadRules",
        component: RoadRulesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRoadRules",
            component: AllRoadRules,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roadrules index",
                subject: "roadrules",
              },
            },
          },
          {
            path: "create",
            name: "CreateRoadRules",
            component: CreateRoadRules,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roadrules create",
                subject: "roadrules",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditRoadRules",
            component: EditRoadRules,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roadrules edit",
                subject: "roadrules",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowRoadRules",
            component: ShowRoadRules,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roadrules show",
                subject: "roadrules",
              },
            },
          },
        ],
      },
      // End:: RoadRules Config

      // Start:: banks  Config
      {
        path: "/banks",
        name: "banks",
        component: BanksHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allbanks",
            component: AllBanks,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks index",
                subject: "banks",
              },
            },
          },
          {
            path: "create",
            name: "Createbanks",
            component: CreateBanks,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks create",
                subject: "banks",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editbanks",
            component: EditBanks,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks edit",
                subject: "banks",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showbanks",
            component: ShowBanks,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks show",
                subject: "banks",
              },
            },
          },
        ],
      },
      // End:: banks Config

      // Start:: payouts Config
      {
        path: "/payouts",
        name: "payouts",
        component: PayoutsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allpayouts",
            component: AllPayouts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "payouts index",
                subject: "payouts",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showpayouts",
            component: ShowPayouts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "payouts show",
                subject: "payouts",
              },
            },
          },
        ],
      },
      // End:: payouts Config

      // Start:: booking payouts Config
      {
        path: "/booking-payouts",
        name: "bookingPayouts",
        component: BookingPayoutsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllbookingPayouts",
            component: AllBookingPayouts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "payouts index",
                subject: "payouts",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowbookingPayouts",
            component: ShowBookingPayout,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "payouts show",
                subject: "payouts",
              },
            },
          },
        ],
      },
      // End:: booking payouts Config

      {
        path: "/auctions",
        name: "auctions",
        component: AuctionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allauctions",
            component: AllAuctions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "auctions index",
                subject: "auctions",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showauctions",
            component: ShowAuctions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "auctions show",
                subject: "auctions",
              },
            },
          },
        ],
      },
      // End:: Auctions Config

      // Start:: packages  Config
      {
        path: "/packages",
        name: "packages",
        component: PackagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allpackages",
            component: AllPackages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages index",
                subject: "packages",
              },
            },
          },
          {
            path: "create",
            name: "Createpackages",
            component: CreatePackages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages create",
                subject: "packages",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editpackages",
            component: EditPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages edit",
                subject: "packages",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showpackages",
            component: ShowPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages show",
                subject: "packages",
              },
            },
          },
        ],
      },
      // End:: packages Config

      // Start:: durations  Config
      {
        path: "/durations",
        name: "durations",
        component: DurationsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Alldurations",
            component: AllDurations,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "auctiondurations index",
                subject: "auctiondurations",
              },
            },
          },
          {
            path: "create",
            name: "Createdurations",
            component: CreateDurations,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "auctiondurations create",
                subject: "auctiondurations",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editdurations",
            component: EditDurations,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "auctiondurations edit",
                subject: "auctiondurations",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showdurations",
            component: ShowDurations,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "auctiondurations show",
                subject: "auctiondurations",
              },
            },
          },
        ],
      },
      // End:: durations Config

      // Start:: ads  Config
      {
        path: "/ads",
        name: "ads",
        component: AdsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAds",
            component: AllAds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements index",
                subject: "advertisements",
              },
            },
          },
          {
            path: "create",
            name: "CreateAds",
            component: CreateAds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements create",
                subject: "advertisements",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAds",
            component: EditAds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements edit",
                subject: "advertisements",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAds",
            component: ShowAds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements show",
                subject: "advertisements",
              },
            },
          },
        ],
      },
      // End:: ads Config

      // Start:: All Notifications Route Config
      {
        path: "/all-notifications",
        name: "NotificationsHome",
        component: NotificationsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllNotifications",
            component: AllNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
          {
            path: "create",
            name: "CreateNotificationss",
            component: CreateNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications create",
                subject: "notifications",
              },
            },
          },
          {
            path: "show",
            name: "ShowAllNotifications",
            component: ShowAllNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowNotificationss",
            component: ShowNotificationsTable,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
        ],
      },
      // End:: All Notifications Route Config

      // Start:: Clients Routes Config
      {
        path: "/Clients",
        name: "ClientsHome",
        component: ClientsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllClients",
            component: AllClients,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients index",
                subject: "clients",
              },
            },
          },
          {
            path: "create",
            name: "CreateClients",
            component: CreateClients,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients create",
                subject: "clients",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditClients",
            component: EditClients,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients edit",
                subject: "clients",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowClients",
            component: ShowClients,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients show",
                subject: "clients",
              },
            },
          },
        ],
      },
      {
        path: "/Providers",
        name: "ProvidersHome",
        component: ProvidersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllProviders",
            component: AllProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers index",
                subject: "providers",
              },
            },
          },
          {
            path: "create",
            name: "CreateProviders",
            component: CreateProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers create",
                subject: "providers",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditProviders",
            component: EditProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers edit",
                subject: "providers",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowProviders",
            component: ShowProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers show",
                subject: "providers",
              },
            },
          },
        ],
      },

      {
        path: "/vehiclesmanagement",
        name: "vehiclesmanagement",
        component: vehiclesmanagementHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllvehiclesmanagementHome",
            component: Allvehiclesmanagement,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclesmanagement requests",
                subject: "vehiclesmanagement",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditvehiclesmanagementHome",
            component: Editvehiclesmanagement,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclesmanagement requests",
                subject: "vehiclesmanagement",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowvehiclesmanagementHome",
            component: Showvehiclesmanagement,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehiclesmanagement requests",
                subject: "vehiclesmanagement",
              },
            },
          },
        ],
      },

      {
        path: "/servicesmanagement",
        name: "servicesmanagement",
        component: servicesmanagementHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllservicesmanagementHome",
            component: Allservicesmanagement,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "servicesmanagement requests",
                subject: "servicesmanagement",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditservicesmanagementHome",
            component: Editservicesmanagement,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "servicesmanagement edit",
                subject: "servicesmanagement",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowservicesmanagementHome",
            component: Showservicesmanagement,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "servicesmanagement show",
                subject: "servicesmanagement",
              },
            },
          },
        ],
      },

      {
        path: "/vehicles",
        name: "vehicles",
        component: VehiclesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllVehicles",
            component: AllVehicles,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehicles management",
                subject: "vehicles",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditVehicle",
            component: EditVehicles,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehicles management",
                subject: "vehicles",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowVehicle",
            component: ShowVehicles,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "vehicles management",
                subject: "vehicles",
              },
            },
          },
        ],
      },
      {
        path: "/bookings",
        name: "bookings",
        component: BookingsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllBookings",
            component: AllBookings,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "bookings index",
                subject: "bookings",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditVehicle",
            component: EditBookings,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "bookings management",
                subject: "bookings",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowVehicle",
            component: ShowBookings,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "bookings show",
                subject: "bookings",
              },
            },
          },
        ],
      },

      {
        path: "/additional-services",
        name: "additional-services",
        component: AdditionalServicesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdditionalServices",
            component: AllAdditionalServices,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additional-services index",
                subject: "additional-services",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAdditionalService",
            component: EditAdditionalServices,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additional-services updateprice",
                subject: "additional-services",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAdditionalService",
            component: ShowAdditionalServices,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additional-services show",
                subject: "additional-services",
              },
            },
          },
        ],
      },

      // End:: Clients Routes Config

      // Start:: Order requests config
      // {
      //   path: "/order-requests",
      //   name: "OrdersRequestsHome",
      //   component: OrdersRequestsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllOrdersRequests",
      //       component: AllOrdersRequests,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "users index",
      //           subject: "users",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowOrdersRequests",
      //       component: ShowOrdersRequests,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "users index",
      //           subject: "users",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: Order requests config

      {
        path: "/students",
        name: "studentsHome",
        component: studentsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allstudents",
            component: Allstudents,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients index",
                subject: "clients",
              },
            },
          },
          {
            path: "create",
            name: "Createstudents",
            component: Createstudents,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients create",
                subject: "clients",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editstudents",
            component: Editstudents,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients edit",
                subject: "clients",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showstudents",
            component: Showstudents,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients show",
                subject: "clients",
              },
            },
          },
        ],
      },

      // Start:: questions Routes Config
      {
        path: "/questions",
        name: "questionsHome",
        component: questionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allquestions",
            component: Allquestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "commonquestion index",
                subject: "commonquestion",
              },
            },
          },
          {
            path: "create",
            name: "Createquestions",
            component: Createquestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "commonquestion create",
                subject: "commonquestion",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editquestions",
            component: Editquestions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "commonquestion edit",
                subject: "commonquestion",
              },
            },
          },
        ],
      },
      // End:: questions Routes Config

      // Start:: Academic Stages Routes Config
      {
        path: "/academic-stages",
        name: "AcademicStagesHome",
        component: AcademicStagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAcademicStages",
            component: AllAcademicStages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "academic stages index",
                subject: "academic-stages",
              },
            },
          },
          {
            path: "create",
            name: "CreateAcademicStages",
            component: CreateAcademicStages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "academic stages create",
                subject: "academic-stages",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAcademicStages",
            component: EditAcademicStages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "academic stages edit",
                subject: "academic-stages",
              },
            },
          },
        ],
      },
      // End:: Academic Stages Routes Config

      // Start:: Categories Routes Config
      {
        path: "/categories",
        name: "CategoriesHome",
        component: CategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCategories",
            component: AllCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "course category index",
                subject: "course-category",
              },
            },
          },
          {
            path: "create",
            name: "CreateCategories",
            component: CreateCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "course category create",
                subject: "course-category",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCategoriess",
            component: EditCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "course category edit",
                subject: "course-category",
              },
            },
          },
        ],
      },
      // End:: Categories Routes Config

      // Start:: Academic Years Routes Config
      {
        path: "/academic-years",
        name: "AcademicYearsHome",
        component: AcademicYearsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAcademicYears",
            component: AllAcademicYears,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "academic years index",
                subject: "academic-years",
              },
            },
          },
          {
            path: "create",
            name: "CreateAcademicYears",
            component: CreateAcademicYears,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "academic years create",
                subject: "academic-years",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAcademicYears",
            component: EditAcademicYears,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "academic years edit",
                subject: "academic-years",
              },
            },
          },
        ],
      },
      // End:: Academic Years Routes Config

      // Start:: specializations Routes Config
      {
        path: "/specializations",
        name: "SpecializationsHome",
        component: SpecializationsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSpecializations",
            component: AllSpecializations,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "specialization index",
                subject: "specialization",
              },
            },
          },
          {
            path: "create",
            name: "CreateSpecializations",
            component: CreateSpecializations,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "specialization create",
                subject: "specialization",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditSpecializations",
            component: EditSpecializations,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "specialization edit",
                subject: "specialization",
              },
            },
          },
        ],
      },
      // End:: specializations Routes Config

      // Start:: Subjects Routes Config
      {
        path: "/subjects",
        name: "SubjectsHome",
        component: SubjectsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSubjects",
            component: AllSubjects,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "study subject index",
                subject: "study-subject",
              },
            },
          },
          {
            path: "create",
            name: "CreateSubjects",
            component: CreateSubjects,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "study subject create",
                subject: "study-subject",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditSubjects",
            component: EditSubjects,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "study subject edit",
                subject: "study-subject",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowSubjects",
            component: ShowSubjects,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "study subject show",
                subject: "study-subject",
              },
            },
          },
        ],
      },
      // End:: Subjects Routes Config

      // Start:: Categories Routes Config
      {
        path: "/main-categories",
        name: "CategoriesHome",
        component: CategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCategories",
            component: AllCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "create",
            name: "CreateCategories",
            component: CreateCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCategories",
            component: EditCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
        ],
      },
      // End:: Categories Routes Config

      // Start:: app-rates Routes Config
      {
        path: "/app-rate",
        name: "AppRatesHome",
        component: AppRatesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAppRates",
            component: AllAppRates,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "rates index",
                subject: "rates",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAppRate",
            component: ShowAppRate,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "rates show",
                subject: "rates",
              },
            },
          },
        ],
      },
      // End:: app-rates Routes Config

      // Start:: app-rates Routes Config
      // {
      //   path: "/store-rate",
      //   name: "StoreRatesHome",
      //   component: StoreRatesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllStoreRates",
      //       component: AllStoreRates,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "rates index",
      //           subject: "rates",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: app-rates Routes Config

      // Start:: sub Categories Routes Config
      // {
      //   path: "/sub-categories",
      //   name: "CategoriesHome",
      //   component: SubCategoriesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllSubCategories",
      //       component: AllSubCategories,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "subcategories index",
      //           subject: "subcategories",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateSubCategories",
      //       component: CreateSubCategories,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "subcategories index",
      //           subject: "subcategories",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditSubCategories",
      //       component: EditSubCategories,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowSubCategories",
      //       component: ShowSubCategories,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "subcategories index",
      //           subject: "subcategories",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: sub Categories Routes Config

      // Start:: management Routes Config
      // {
      //   path: "/managements",
      //   name: "ManagementsHome",
      //   component: ManagementsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllManagements",
      //       component: AllManagements,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "management index",
      //           subject: "management",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateManagements",
      //       component: CreateManagements,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "management index",
      //           subject: "management",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditManagements",
      //       component: EditManagements,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowManagements",
      //       component: ShowManagements,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "management index",
      //           subject: "management",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: management Routes Config

      // Start:: Capacities  Config
      // {
      //   path: "/Capacities",
      //   name: "CapacitiesHome",
      //   component: CapacitiesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllCapacitiesHome",
      //       component: AllCapacities,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "capacities index",
      //           subject: "capacities",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateCapacities",
      //       component: CreateCapacities,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "capacities create",
      //           subject: "capacities",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditCapacities",
      //       component: EditCapacities,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "capacities edit",
      //           subject: "capacities",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowCapacities",
      //       component: ShowCapacities,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "capacities show",
      //           subject: "capacities",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: Capacities Config

      // Start:: Complaints Management Routes Config
      {
        path: "/complaints",
        name: "ComplaintsList",
        component: ComplaintsList,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "complaints index",
            subject: "complaints",
          },
        },
      },
      // End:: Complaints Management Routes Config

      // Start:: Chatbot FAQs Routes Config
      {
        path: "/chatbot-faqs",
        name: "ChatbotFaqsList",
        component: ChatbotFaqsList,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "chatbotfaqs index",
            subject: "chatbotfaqs",
          },
        },
      },
      // End:: Chatbot FAQs Routes Config

      // Start:: Chatbot Conversations Routes Config
      {
        path: "/chatbot-conversations",
        name: "ChatbotConversations",
        component: ChatbotConversations,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "chatbotfaqs index",
            subject: "chatbotfaqs",
          },
        },
      },
      // End:: Chatbot Conversations Routes Config

      // Start:: Provider Wallet Withdrawal Requests Routes Config
      {
        path: "/provider-wallet-requests",
        name: "ProviderWalletRequests",
        component: ProviderWalletRequests,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "wallets index",
            subject: "wallets",
          },
        },
      },
      // End:: Provider Wallet Withdrawal Requests Routes Config

      // Start:: Delivery Wallet Withdrawal Requests Routes Config
      {
        path: "/delivery-wallet-requests",
        name: "DeliveryWalletRequests",
        component: DeliveryWalletRequests,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "wallets index",
            subject: "wallets",
          },
        },
      },
      // End:: Delivery Wallet Withdrawal Requests Routes Config
      // End:: Wallet Withdrawal Requests Routes Config

      // Start:: App contact Routes Config
      {
        path: "/contact_settings",
        component: GeneralSettings,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings create",
            subject: "settings",
          },
        },
      },
      {
        path: "/app_settings",
        component: AppSettings,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings edit",
            subject: "settings",
          },
        },
      },
      {
        path: "/statistics_settings",
        component: StatisticsSettings,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings edit",
            subject: "settings",
          },
        },
      },
      // End:: App contact Routes Config
    ],
  },
  // ***************** End:: Content Routes Config

  // ***************** Start:: Forbidden Route Config
  {
    path: "/forbidden",
    name: "ForbiddenPage",
    component: ForbiddenPage,
  },
  // ***************** End:: Forbidden Route Config

  // ***************** Start:: Not Found Route Config
  {
    path: "/:notFound(.*)",
    name: "NotFoundPage",
    component: NotFoundPage,
  },
  // ***************** End:: Not Found Route Config
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
  routes,
});

// Start:: Middleware And Router Guards
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

// Authentication and Permission Check Middleware
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem(
    "Dos_admin_dashboard_user_token"
  );

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, router, to };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  } else if (isAuthenticated) {
    const publicRoutes = [
      "LoginForm",
      "ResetPasswordEmailForm",
      "PhoneVerification",
      "ChangePhoneNumberForm",
      "ResetPasswordForm",
    ];

    if (publicRoutes.includes(to.name)) {
      return next("/home");
    }
  }

  if (to.meta.requiresPermission) {
    const { action, subject } = to.meta.requiresPermission;
    const storedPermissions = JSON.parse(
      localStorage.getItem("Dos_admin_roles")
    )?.permissions;

    if (
      storedPermissions &&
      storedPermissions.some(
        (permission) =>
          permission.action === action && permission.subject === subject
      )
    ) {
      return next();
    } else {
      return next("/forbidden");
    }
  }

  return next();
});

export default router;
